export function createElementName(pageName: string, elementName: string, elementTypeName: string): string {
  return `${pageName}_${elementName}_${elementTypeName}`;
}
export function createPostFixedElementName(fullElementName: string, postFix : number | string): string {
  return `${fullElementName}_${postFix}`;
}
